import Footer from "@/components/feature/Footer";
import Navbar from "@/components/feature/Navbar";

export default function AccountDeletionPage() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Navbar />
      <main className="mx-auto max-w-4xl px-6 py-16">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#1A8C7A]">
          Donnees personnelles
        </p>
        <h1 className="mt-3 text-3xl font-bold md:text-4xl">
          Demander la suppression de son compte
        </h1>
        <p className="mt-4 text-sm text-gray-500">
          Derniere mise a jour: 8 juillet 2026
        </p>

        <section className="mt-10 space-y-5 text-gray-700 leading-relaxed">
          <p>
            Les membres ASC Sonatel peuvent initier la suppression de leur compte depuis
            l'application mobile, dans les parametres du profil. Une demande est alors
            enregistree et transmise a l'administration de l'association.
          </p>

          <h2 className="text-xl font-semibold text-gray-900">Demande depuis le web</h2>
          <p>
            Si vous n'avez plus acces a l'application, envoyez votre demande depuis
            l'adresse email liee au compte, en indiquant votre nom, prenom et numero de
            telephone membre.
          </p>
          <a
            href="mailto:admin@ascsonatel.com?subject=Demande%20de%20suppression%20de%20compte%20ASC%20Sonatel"
            className="inline-flex items-center justify-center rounded-lg bg-[#E8521A] px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#d94a16]"
          >
            Envoyer une demande
          </a>

          <h2 className="text-xl font-semibold text-gray-900">Traitement</h2>
          <p>
            ASC Sonatel verifie l'identite du demandeur avant suppression. Les donnees
            non soumises a une obligation administrative, associative ou comptable sont
            supprimees ou anonymisees apres traitement.
          </p>

          <h2 className="text-xl font-semibold text-gray-900">Donnees conservees</h2>
          <p>
            Certaines informations peuvent etre conservees si elles sont necessaires a la
            gestion des cotisations, commandes, justificatifs, obligations legales ou
            prevention des abus. Elles ne sont pas utilisees a des fins commerciales.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
